import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";

const SessionKeyPage = () => {
  const { sessionKey } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateAndRedirect = async () => {
      try {
        Cookies.remove('apiKey');
        Cookies.remove('sessionKey');

        // Validate session key
        const res = await axios.post(
          `${process.env.REACT_APP_PROXY}/session/validate-key`,
          { sessionKey }
        );
        if (res.data?.message !== 'SessionKey validated successfully') {
          throw new Error('SessionKey validation failed.');
        }
        Cookies.set('sessionKey', sessionKey, { sameSite: 'strict', secure: true });
        navigate('/');
      } catch (err) {
        alert(
          err.response?.data?.error ||
          'There is a problem with this session key. Contact support.'
        );
        navigate('/');
      } finally {
        setLoading(false);
      }
    };
    validateAndRedirect();
  }, [sessionKey, navigate]);

  if (loading) {
    return (
      <div className="bg-gray d-flex justify-content-center align-items-center vh-100">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} sm={8} md={6}>
              <Card className="shadow p-4 text-center">
                <Card.Body>
                  <Spinner animation="border" variant="dark" />
                  <p className="mt-3">loading ...</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  // Fallback (should never reach here)
  return null;
};

export default SessionKeyPage;
